import { createSlice } from '@reduxjs/toolkit';
import { getStoreList } from './Connect.action';
import { getIntegrationErrorMappings } from './Connect.action';
import { setSingleValue } from './Connect.action';

const initialState = {
  stores: {},
  groupedStoresList: {},
  setSingleValue: null,
  newIntegrationDetails: {},
  isNewChannelConnected: false
};

export const connectListSlice = createSlice({
  name: 'connect',
  initialState,
  reducers: {
    setNewIntegrationInfo: (state, action) => {
      state.newIntegrationDetails = action.payload;
    },
    setIsNewChannelConnected: (state, action) => {
      state.isNewChannelConnected = action.payload;
    },
    removeKey: (state, action) => {
      delete state[action?.payload];
    }
  },
  extraReducers: builder => {
    builder.addCase(getStoreList.pending, state => {
      state.stores = { loading: true, error: false, list: [] };
    });
    builder.addCase(getStoreList.fulfilled, (state, action) => {
      state.stores = {
        loading: false,
        error: false,
        list: action.payload.updatedList,
        nameList: action.payload.channelNameList
      };
      state.groupedStoresList = action.payload.groupedList;
    });
    builder.addCase(getStoreList.rejected, state => {
      state.stores = {
        loading: false,
        error: true,
        list: [],
        nameList: []
      };
    });
    builder.addCase(getIntegrationErrorMappings.pending, state => {
      state.integrationErrorMappings = { loading: true, error: false, list: [] };
    });
    builder.addCase(getIntegrationErrorMappings.fulfilled, (state, action) => {
      state.integrationErrorMappings = {
        loading: false,
        error: false,
        list: action.payload
      };
    });
    builder.addCase(getIntegrationErrorMappings.rejected, state => {
      state.integrationErrorMappings = {
        loading: false,
        error: true,
        list: []
      };
    });
    builder.addCase(setSingleValue, (state, action) => {
      state.stores.list = action.payload;
    });
  }
});

export const { setNewIntegrationInfo, setIsNewChannelConnected, removeKey } = connectListSlice.actions;

export default connectListSlice.reducer;
